import alcoholFollowup from './followup';
import alcohol from './initial';

const alcoholFlows = { alcoholFollowup, alcohol };
export default alcoholFlows;
